import { Client } from "../../clients/client";
import { PaginationForm, Pagination } from "@/common/mixins/pagination";
import { DeliveryMode } from "./models/DeliveryMode";
import { Shop } from "../shop/models/Shop";
import { DeliveryShopSetAttributeForm } from "./forms/DeliveryShopSetAttributeForm";
import { DeliveryModeAttributeMeta } from "./models/DeliveryModeAttributeMeta";
import { DeliveryRawStatusForm } from "./forms/DeliveryRawStatusForm";

export class DeliveryModeUseCase {
  constructor(private client: Client) {}
  async getDeliveryModes(
    form: PaginationForm
  ): Promise<Pagination<DeliveryMode>> {
    return this.client.deliveryMode.getDeliveryModes({
      page: form && form.page,
      limit: form && form.perPage,
      search: form.search
    });
  }

  async getShopByDeliveryId(
    deliveryId: number,
    form: PaginationForm
  ): Promise<Pagination<Shop>> {
    return this.client.shopDelivery.getShopByDeliveryId(deliveryId, {
      page: form && form.page,
      limit: form && form.perPage,
      search: form.search
    });
  }

  async getDeliveryAttributeByDeliveryId(deliveryId: number) {
    return this.client.deliveryMode.getDeliveryAttributeByDeliveryId(
      deliveryId
    );
  }

  async getDeliveryModesByShopId(shopId: number) {
    return this.client.deliveryMode.getDeliveryModesByShopId(shopId);
  }

  async getDelivertShopAttributes(form: DeliveryShopSetAttributeForm) {
    return this.client.shopDelivery.getDeliveryShopAttribute({
      shopId: form.shop?.id!,
      deliveryId: form.deliveryId!
    });
  }

  async createDeliveryShopAttribute(form: DeliveryShopSetAttributeForm) {
    const newAttribute = form.attributes
      ?.filter(attribute => {
        return attribute.value != "";
      })
      .map(attribute => {
        return {
          id: attribute.id,
          key: attribute.name,
          value: attribute.value!
        };
      });
    return this.client.shopDelivery.postDeliveryShopAttribute({
      shopId: form.shop?.id!,
      deliveryId: form.deliveryId!,
      attributes: newAttribute!
    });
  }

  mappingDeliveryShopAttributes(
    deliveryModeAttribute: DeliveryModeAttributeMeta[],
    attributes: any
  ): DeliveryModeAttributeMeta[] {
    const deliveryShopAttribute = Object.keys(attributes).map(key => {
      const attribute = deliveryModeAttribute.find(attribute => {
        return attribute.name == key;
      })!;
      return { ...attribute, value: attributes[key] };
    });

    return deliveryModeAttribute.map(attribute => {
      let value = "";
      const shopValue = deliveryShopAttribute.find(shopAttribute => {
        return shopAttribute.id == attribute.id;
      });

      if (shopValue) {
        value = shopValue.value;
      }
      return { ...attribute, value };
    });
  }

  async createDeliveryRawStatusMapping(form: DeliveryRawStatusForm) {
    return this.client.rawStatusMapping.postDeliveryRawStatus(form);
  }

  async getDeliveryRawStatusByDeliveryId(id: number) {
    return this.client.rawStatusMapping.getDeliveryRawStatusByDeliveryId(id);
  }

  async updateDeliveryRawStatusMapping(form: DeliveryRawStatusForm) {
    return this.client.rawStatusMapping.patchDeliveryRawStatus(form);
  }
}
